module.exports = __webpack_public_path__ + "static/media/PushtimargImage18.c8835cc1.jpg";